import React, { useEffect, useRef, useState } from 'react';
import Select from "react-select";
import { useNavigate, Link } from "react-router-dom";
import styled from "styled-components";
import dayjs from "dayjs";
import CopyToClipboard from 'react-copy-to-clipboard';
import { BsFillPersonCheckFill, BsListStars, BsPencilFill, BsPersonVcard, BsPlusSquareDotted, BsTrash3, BsWhatsapp } from 'react-icons/bs';
import { FaEye, FaHeartbeat, FaShoppingBasket, FaSortDown, FaSortUp, FaSpinner, FaTags } from 'react-icons/fa';
import { ImCopy } from 'react-icons/im';
import { IoClose } from 'react-icons/io5';
import { CgNotes } from 'react-icons/cg';
import { TiShoppingCart } from 'react-icons/ti';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import useAPI from '../../../hooks/useAPI';
import Modal from '../../layout/Modal';
import {questionToast, sendToast} from "../../plugins/toastAll";
import { resolveInternationalPhone } from '../../../utils/phone';

const ContactInfo = ({ 
    dataContactInfo, 
    setShowContactInfo, 
    setDataContactInfo, 
    allLists, 
    handleChangeList, 
    addUserToList, 
    isDisableSelect, 
    customStyles, 
    customStylesDark, 
    isDark, 
    Botton,
    Icon,
    Avvvatars,
    Alert,
    ordersFilteredInfo,
    formPutPerson,
    error8,
    fieldsList,
    setLoading,
    reloadDataContact,
    contactStage,
    reset,
    addNewSegment,
    setAddNewSegment,
    setIsDisableSelect
}) => {
    const [notesSection, setNotesSection] = useState(false);
    const [tagsSection, setTagsSection] = useState(false);
    const [listsSection, setListsSection] = useState(false); 
    const [responsibleSection, setResponsibleSection] = useState(false); 
    const [ordersSection, setOrdersSection] = useState(false);
    const [dataSection, setDataSection] = useState(false); 
    const [isFeelings, setIsFeelings] = useState(false);
    const [isInterestedBuying, setIsInterestedBuying] = useState(false);
    const [noteSelected, setNoteSelected] = useState([])
    const [modeEdit, setModeEdit] = useState(false);
    const [addNewNote, setAddNewNote] = useState(false);
    const [loadingGetNote, setLoadingGetNote] = useState(false);
    const [modalViewNote, setModalViewNote] = useState(false);
    const [idNote, setIdNote] = useState(false);
    const [newNote, setNewNote] = useState("");

    const userLogout = localStorage.getItem("USER_NAME");

    const { urlAPI_1, urlAPI_2, urlAPI_3, urlSocket, fetchWithAuth } = useAPI();

    //# Navegacion
    const navigate = useNavigate();

    //--------------------Notas-------------------
      //Funcion que obtiene una nota
    const getNote = async (id) => {
        setLoadingGetNote(true)
        setModeEdit(true);
        setAddNewNote(true);
        setIdNote(id);
        try {
            console.log("getNote ID: ", id);
            const url = urlAPI_1 + "notes/" + dataContactInfo.phone + "/" + id;
            const options = { method: "GET", mode: "cors"};
            const response = await fetchWithAuth(url, options);
            const result = await response.json();
            console.log("getNote result: ", result);

            if (result.code === 0) {
            sendToast(result)
            } else if (result.data.length === 0) {
            setNewNote("");
            } else {
            setNewNote(result.data[0].note || "");
            }
            setLoadingGetNote(false)

        } catch (error) {
            console.log(error);
        }
    };

    //Ver infromación de la nota seleccionada
    const viewNote = async (data) => {
        setNoteSelected(data)
        setModalViewNote(true)
    }
    //Enviar nueva nota
    const postNote = async () => {
        const note = newNote;
        var date = new Date();

        var object = {
            note: note,
            date: date,
            agent: userLogout,
        };
        try {
            setLoading(true);
            const url = urlAPI_1 + "addNote/" + dataContactInfo.phone;
            const options = { method: "POST", mode: "cors", body: JSON.stringify(object)};
            const response = await fetchWithAuth(url, options);
            const result = await response.json();

            reset({ note: "" });
            setNewNote("");
            setAddNewNote(false);
            await reloadDataContact(contactStage);
            setLoading(false);
            sendToast(result)
        } catch (error) {
            console.log(error);
        }
    };

    //Función para editar una nota
    const putNote = async () => {
        const note = newNote;
        var date = new Date();

        var newObject = {
            note: note,
            date: date,
            agent: userLogout,
            id: idNote,
        };
        try {
            setLoading(true);
            const url = urlAPI_1 + `addNote/${dataContactInfo.phone}`;
            const options = { method: "PUT", mode: "cors", body: JSON.stringify(newObject)};
            const response = await fetchWithAuth(url, options);
            const result = await response.json();

            reset({ note: "" });
            setAddNewNote(false);
            await reloadDataContact(contactStage);
            setLoading(false);
            sendToast(result)
        } catch (error) {
            console.log(error);
        }
    };

    //Función para eliminar una nota
    const deleteNote = async (id) => {
        try {
            const data = {
            isFetch: true,
            fetch: {
                url: urlAPI_1 + `notes/${dataContactInfo.phone}/${id}`,
                options: { 
                method: "DELETE", 
                mode: "cors"
                }
            },
            title: "¿Estas seguro que deseas eliminar esta nota?",
            text: "No podrás recuperarla.",
            icon: "warning",
            buttons: { success: "Eliminar", cancel: "Cancelar" }
            };
        
            console.log("Datos enviados a questionToast:", data);
            const result = await questionToast(data, setLoading);
            console.log("Result -------->: ", result);

            await reloadDataContact(contactStage);
            sendToast(result)
        } catch (error) {
            console.log(error);
        }
    };

    //--------------Persona---------------
    //Funcion para actualizar
    const putPerson = async () => {
        const objectData = formPutPerson.watch();
        const id = objectData._id;
        let tags = []
        for(let tag of dataContactInfo.tags){
            if (tag.tagActive) {
            tags.push(tag._id)
            }
        }
        objectData.tags = tags.join(',');
        objectData.responsible = userLogout;
        try {
            setLoading(true);
            const url = urlAPI_1 + `persons/${id}`;
            const options = { method: "PUT", mode: "cors", body: JSON.stringify(objectData)};
            const response = await fetchWithAuth(url, options);
            const result = await response.json();
            await reloadDataContact(contactStage);
            setLoading(false);
            sendToast(result)
        } catch (error) {
            setLoading(false);
        }
    };

return (
    <>
        <div className="prospect-info m-1 container-list-prospects">
            <div className='module-chat info active h-100'>
                <header className="message d-flex" style={{height:"6%"}}>
                    <div className="d-flex">
                        <div style={{ alignItems: "center", display: "flex" }}>
                            <Botton
                                type="button"
                                onClick={() => {
                                setShowContactInfo(false)
                                setDataContactInfo(null);
                                }}
                            >
                                <IoClose className="icon-cancel" style={{ fontSize: "1.5rem" }} />
                            </Botton>
                        </div>
                        <div id="customer-name" className="ml-2 d-flex">
                            <h1>Info. del Prospecto</h1>
                        </div>
                    </div>
                </header>

                <div className="user-information mp-2" style={{ height: "93%", overflow: "auto" }}>
                    <ul className="chat">
                        <li>
                            <Icon>
                                <Avvvatars value={dataContactInfo.name} />
                            </Icon>
                        </li>
                        <li className="text-center">
                            <h5>{dataContactInfo.name}</h5>
                        </li>
                        <li className="text-center">
                            <p className="d-flex align-items-center justify-content-center span-color">
                                {/* <BsWhatsapp 
                                    className="mr-1 pointer" 
                                    style={{ fontSize: "23px", color: "#00a884" }} 
                                    data-tooltip-id="my-tooltip" 
                                    data-tooltip-content="Enviar mensaje"
                                    onClick={dataContactInfo.wpp_enabled ? () => {
                                        navigate(`/home/chat`, { 
                                        state: { 
                                            parametro: resolveInternationalPhone(dataContactInfo.callingCode, dataContactInfo.phone),
                                            idContact: dataContactInfo._id,
                                            isChat: true
                                        } 
                                        })
                                    } : undefined}
                                    disabled={!dataContactInfo.wpp_enabled}
                                />*/}
                                +{resolveInternationalPhone(dataContactInfo.callingCode, dataContactInfo.phone)}
                                <CopyToClipboard text={dataContactInfo.phone}>
                                    <a
                                        href="javascript:;"
                                        className="ml-1 d-flex align-items-center"
                                        data-tooltip-id="my-tooltip" data-tooltip-content="Copiar teléfono"
                                        onClick={() => 
                                        // toastt.success("Copiado!")
                                        sendToast({type: "success", message: "Número copiado al portapapeles"})
                                        }
                                    >
                                        <ImCopy style={{ fontSize: "18px" }} />
                                    </a>
                                </CopyToClipboard>
                
                            </p>
                        </li>
                    </ul>
                    <div>
                        {/* Informacion Personal */}
                        <div className="main-data">
                            <h5 className="pointer d-flex justify-content-between"
                                onClick={() => {
                                    setTagsSection(false);
                                    setNotesSection(false);
                                    setListsSection(false);
                                    setResponsibleSection(false);
                                    setOrdersSection(false);
                                    setIsFeelings(false);
                                    setIsInterestedBuying(false);
                                    setDataSection(prev => !prev);
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <BsPersonVcard className="mr-1"/>
                                    Datos principales
                                </div>
                                {dataSection ?
                                    <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                                    <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                                }
                            </h5>
                            {dataSection && (
                                <form onSubmit={formPutPerson.handleSubmit(putPerson)}>
                                    <Div className="justify-content-center pt-2">
                                        <div className="form-group mr-0 col-6 span-color">
                                            <label htmlFor="email">Correo:</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="email"
                                                id="email"
                                                {...formPutPerson.register("email", {
                                                    pattern: {
                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                        message: "Formato incorrecto",
                                                    },
                                                })}
                                            />
                                            {error8.email && <Alert className="w-100">* {error8.email.message}</Alert>}
                                        </div>
                                        <div className="form-group mr-0 col-6 span-color">
                                            <label htmlFor="name">Nombre:</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="name"
                                                id="name"
                                                {...formPutPerson.register("name", {
                                                    required: {
                                                        value: true,
                                                        message: "El nombre es requerido.",
                                                    },
                                                    pattern: {
                                                        value: /\S+/,
                                                        message: "No puede ser solo espacios en blanco",
                                                    },
                                                })}
                                            />
                                            {error8.name && <Alert>* {error8.name.message}</Alert>}
                                        </div>
                                        
                                        {fieldsList && fieldsList.length && fieldsList.map((field, k) => (
                                            <div key={k} className="form-group mr-0 col-6 span-color">
                                                <label htmlFor={field.name}>{field.name}</label>
                                                {field.type === "textarea" ? (
                                                    <textarea
                                                        name={field.name}
                                                        className="form-control"
                                                        id={field.name}
                                                        {...formPutPerson.register(field.name)}
                                                    ></textarea>
                                                ) : (
                                                    <input
                                                        type={field.type}
                                                        className="form-control"
                                                        name={field.name}
                                                        id={field.name}
                                                        {...formPutPerson.register(field.name)}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </Div>
                                    <div className="text-right pr-2">
                                        <input
                                            className="btn btn-lg btn-info"
                                            style={{ fontSize: "0.89em" }}
                                            value="Actualizar"
                                            name="submit"
                                            id="submit"
                                            type="submit"
                                        />
                                    </div>
                                </form>
                            )}
                        </div>

                        {/* Notas */}
                        <div className="condition">
                            <h5
                                className="pointer d-flex justify-content-between"
                                onClick={() => {
                                    setTagsSection(false);
                                    setDataSection(false);
                                    setListsSection(false);
                                    setResponsibleSection(false);
                                    setOrdersSection(false);
                                    setIsFeelings(false);
                                    setIsInterestedBuying(false);
                                    setNotesSection(prev => !prev);
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <CgNotes className="mr-1"/>
                                    Notas
                                </div>
                                {notesSection ?
                                    <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                                    <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                                }
                            </h5>
                            {notesSection && (
                                <>
                                    <div className="mt-3" style={{borderBottom: "2px solid rgb(229 231 235 / 51%)",}}>
                                        <ul className="list-notes" style={{ marginLeft: "10px" }}>
                                            {dataContactInfo.notes && dataContactInfo.notes.length > 0 ? (
                                                dataContactInfo.notes.map((note, k) => (
                                                    <li key={k} className="py-1 d-flex justify-content-between pointer span-color">
                                                        <div>- {note.note.length >= 35
                                                            ? note.note.substr(0, 35) + "..."
                                                            : note.note
                                                        }</div>
                                                        <div className="d-flex">
                                                            <FaEye className="icon-pencil mr-2" title="Ver" style={{ fontSize: "15px" }} onClick={() => viewNote(note)}/>
                                                            <BsPencilFill className="icon-pencil mr-2" title="Editar" style={{ fontSize: "15px" }} onClick={() => getNote(note.id)}/>
                                                            <BsTrash3 className="icon-trash-empty" title="Eliminar" style={{ fontSize: "15px" }} onClick={() => deleteNote(note.id)}/>
                                                        </div>
                                                    </li>
                                                ))
                                            ) : (
                                                <div className="span-color text-center">
                                                    No hay notas
                                                </div>
                                            )}
                                        </ul>
                                    </div>
                                    {addNewNote ? (
                                        <form>
                                            <Div className="col-md-12">
                                                <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable span-color">
                                                    <label htmlFor="phone">{`${modeEdit ? 'Editar' : 'Agregar'} nota:`}</label>
                                                    <div className="su-control-group">
                                                        {loadingGetNote ? 
                                                            <div className="loading-send-template d-flex justify-content-center align-items-center">
                                                                <span style={{ padding: "12px" }}>
                                                                    <FaSpinner className="fa-spin" style={{ fontSize: "25px" }} />
                                                                </span>
                                                            </div>
                                                        :
                                                            <textarea
                                                                name="note"
                                                                className="form-control"
                                                                id="note"
                                                                value={newNote}
                                                                onChange={(e) => setNewNote(e.target.value)}
                                                            ></textarea>
                                                        }
                                                    </div>
                                                </div>
                                            </Div>
                                            <div className="text-right pr-2">
                                                <a
                                                    style={{ fontSize: "0.89em" }}
                                                    href="javascript:;"
                                                    className="btn btn-lg btn-default mr-1"
                                                    onClick={() => {
                                                        setModeEdit((prevMessage) => { return false});
                                                        setAddNewNote((prevMessage) => { return false});
                                                    }}
                                                >
                                                    Cancelar
                                                </a>
                                                <input
                                                    style={{ fontSize: "0.89em" }}
                                                    className="btn btn-lg btn-info"
                                                    value={modeEdit ? "Actualizar" : "Guardar"}
                                                    name="submit"
                                                    id="submit"
                                                    type="button"
                                                    onClick={() => modeEdit ? putNote() : postNote()}
                                                />
                                            </div>
                                        </form>
                                    ) : (
                                        <div className="d-flex justify-content-center">
                                            <button
                                                type="button"
                                                className="btn btn-link btn-link-blue btn-toggle btn-personalize mb-1 d-flex"
                                                onClick={() => {
                                                    setAddNewNote(true);
                                                    setModeEdit(false)
                                                    reset({ note: "" });
                                                }}
                                            >
                                                <BsPlusSquareDotted className="mr-1" style={{ fontSize: "16px" }}/>
                                                Agregar nota
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        {/* Listas */}
                        <div className="segments">
                            <h5
                                className="pointer d-flex justify-content-between"
                                onClick={() => {
                                    setTagsSection(false);
                                    setDataSection(false);
                                    setNotesSection(false);
                                    setResponsibleSection(false);
                                    setOrdersSection(false);
                                    setIsFeelings(false);
                                    setIsInterestedBuying(false);
                                    setListsSection(prev => !prev);
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <BsListStars className="mr-1"/>
                                    Listas
                                </div>
                                {listsSection ?
                                    <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                                    <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                                }
                            </h5>
                            {listsSection && (
                                <form>
                                    <Div className="col-md-12">
                                        <div className="su-control su-with-prefix su-with-suffix su-segmentation-disable">
                                            <div className="su-control-group">
                                                <Select
                                                    styles={isDark == 'true' ? customStylesDark : customStyles}
                                                    className="form-control basic-multi-select"
                                                    isMulti
                                                    value={dataContactInfo.lists}
                                                    placeholder="Seleccione..."
                                                    name="tags"
                                                    onChange={handleChangeList}
                                                    options={allLists}
                                                    classNamePrefix="select"
                                                    noOptionsMessage="Sin opciones"
                                                    getOptionLabel={(option) => (
                                                        <div className="option d-flex options-list-multi" style={{fontSize: "15px"}}>
                                                            {option.name}
                                                        </div>
                                                    )}
                                                    getOptionValue={(option) => option._id}
                                                    isDisabled={isDisableSelect}
                                                />
                                            </div>
                                        </div>
                                    </Div>
                                    {addNewSegment ? (
                                        <div className="text-right pr-2 mt-3">
                                            <a
                                                href="javascript:;"
                                                style={{ fontSize: "0.89em" }}
                                                className="btn btn-lg btn-default mr-1"
                                                onClick={() => {
                                                    setAddNewSegment((prevMessage) => { return false});
                                                    setIsDisableSelect((prevMessage) => { return true});
                                                }}
                                            >
                                                Cancelar
                                            </a>
                                            <input
                                                style={{ fontSize: "0.89em" }}
                                                className="btn btn-lg btn-info"
                                                value="Guardar"
                                                name="submit"
                                                id="submit"
                                                type="button"
                                                onClick={() => addUserToList()}
                                            />
                                        </div>
                                    ):(
                                        <div className="d-flex justify-content-center">
                                            <button
                                                type="button"
                                                className="btn btn-link btn-link-blue btn-toggle btn-personalize mb-1 d-flex"
                                                onClick={() => {
                                                    setAddNewSegment(true);
                                                    setIsDisableSelect(false);
                                                }}
                                            >
                                                <BsPencilFill className="mr-1" style={{ fontSize: "16px" }}/>
                                                Agregar o eliminar lista
                                            </button>
                                        </div>
                                    )}
                                </form>
                            )}
                        </div>
                        
                        {/* Responsable */}
                        {dataContactInfo.responsible && (
                            <div className="condition">
                                <h5
                                    className="pointer d-flex justify-content-between"
                                    onClick={() => {
                                        setTagsSection(false);
                                        setDataSection(false);
                                        setNotesSection(false);
                                        setListsSection(false);
                                        setOrdersSection(false);
                                        setIsFeelings(false);
                                        setIsInterestedBuying(false);
                                        setResponsibleSection(prev => !prev);
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <BsFillPersonCheckFill className="mr-1"/>
                                        Responsable
                                    </div>
                                    {responsibleSection ?
                                        <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                                        <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                                    }
                                </h5>
                                {responsibleSection && (
                                    <div className="mt-3 mb-2 text-center">{dataContactInfo.responsible}</div>
                                )}
                            </div>
                        )}
                        
                        {/* Etiquetas */}
                        {dataContactInfo.tags && (
                            <div className="condition">
                                <h5
                                    className="pointer d-flex justify-content-between"
                                    onClick={() => {
                                        setNotesSection(false);
                                        setDataSection(false);
                                        setListsSection(false);
                                        setResponsibleSection(false);
                                        setOrdersSection(false);
                                        setIsFeelings(false);
                                        setIsInterestedBuying(false);
                                        setTagsSection(prev => !prev)
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <FaTags className="mr-1"/>
                                        Etiquetas
                                    </div>
                                    {tagsSection ?
                                        <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                                        <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                                    }
                                </h5>
                                {tagsSection && (
                                    <div className="mt-3 mb-2 text-center">
                                        <ul className="justify-content-center" style={{display:"grid"}}>
                                            {dataContactInfo.tags && dataContactInfo.tags.length > 0 ? (
                                                dataContactInfo.tags.map((tag, t) => (
                                                    <li key={t} className="m-1 px-2 py-1" style={{backgroundColor: tag.color, color: "#fff", borderRadius: "6px"}}>
                                                        <span style={{fontWeight: "600"}}>{tag.title}</span>
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="span-color">No hay etiquetas</li>
                                            )}
                                        </ul>

                                    </div>
                                )}
                            </div>
                        )}

                        {/* Ordenes */}
                        {ordersFilteredInfo && ordersFilteredInfo.length > 0 && (
                            <div className="condition">
                                <h5
                                    className="pointer d-flex justify-content-between"
                                    onClick={() => {
                                        setNotesSection(false);
                                        setDataSection(false);
                                        setListsSection(false);
                                        setResponsibleSection(false);
                                        setTagsSection(false)
                                        setIsFeelings(false)
                                        setIsInterestedBuying(false);
                                        setOrdersSection(prev => !prev)
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <TiShoppingCart className="mr-1"/>
                                        Pedidos
                                    </div>
                                    {ordersSection ?
                                        <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                                        <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                                    }
                                </h5>
                                {ordersSection && (
                                    <div className="mt-3 mb-2 text-center">
                                        <ul className="justify-content-center" style={{display:"grid"}}>
                                            {
                                                ordersFilteredInfo.slice(0,8).map((order) => (
                                                <li key={order._id} className="m-1 px-2 py-1">
                                                    <Link to={`/home/order/${order._id}`} className='span-color d-flex align-items-center px-1'>
                                                        <FaShoppingBasket className="mr-1"/> Pedido N° {order.id} por {order.total}
                                                    </Link>
                                                </li>
                                                ))
                                            }
                                            {
                                                ordersFilteredInfo.length > 8 && (
                                                    <li className='mx-2 px-2' style={{fontWeight: "700"}}>
                                                        <Link to={`/home/orders`} className='text-info MuiButton-textPrimary'>
                                                            Ver más...
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Sentimientos */}
                        {dataContactInfo.feelings.length > 0 && (
                            <div className="condition">
                                <h5
                                    className="pointer d-flex justify-content-between"
                                    onClick={() => {
                                        setDataSection(false);
                                        setNotesSection(false);
                                        setListsSection(false);
                                        setResponsibleSection(false);
                                        setTagsSection(false);
                                        setOrdersSection(false);
                                        setIsInterestedBuying(false);
                                        setIsFeelings(prevCondition => !prevCondition);
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <FaHeartbeat className="mr-1"/>
                                        Sentimientos
                                    </div>
                                    {isFeelings ?
                                        <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                                        <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                                    }
                                </h5>
                                {isFeelings && (
                                    <div className="mt-3">
                                        <ul className="list-notes mx-2">
                                            <div className="row pb-2 fw-bold text-center" style={{borderBottom: "1px solid"}}>
                                                {["Agente", "Fecha", "Sentimiento"].map((header, index) => (
                                                    <div key={index} className="col">
                                                        <h5 className="fs-5">{header}</h5>
                                                    </div>
                                                ))}
                                            </div>
                        
                                            {dataContactInfo.feelings?.map((f, k) => (
                                                <li key={k} className="row py-2 text-center align-items-center" style={{borderBottom: "1px dashed"}}>
                                                    {[f.user, dayjs(f.date).locale("es").format("DD/MM/YYYY HH:mm"), `${f.feeling ? f.feeling[1] : "80% Neutral" } ${f.feeling ? f.feeling[0] : "😐"}`].map((content, index) => (
                                                        <div key={index} className="col">{content}</div>
                                                    ))}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Interes de compra */}
                        {dataContactInfo.buyingInterest.length > 0 && (
                            <div className="condition">
                                <h5
                                    className="pointer d-flex justify-content-between"
                                    onClick={() => {
                                        setDataSection(false);
                                        setNotesSection(false);
                                        setListsSection(false);
                                        setResponsibleSection(false);
                                        setTagsSection(false);
                                        setOrdersSection(false);
                                        setIsFeelings(false);
                                        setIsInterestedBuying(prevCondition => !prevCondition);
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <RiMoneyDollarCircleLine className="mr-1"/>
                                        Interés de Compra
                                    </div>
                                    {isInterestedBuying ?
                                        <FaSortUp className="pointer mr-1" style={{ fontSize: "18px", marginTop: "5px" }}/> :
                                        <FaSortDown className="pointer mr-1" style={{ fontSize: "18px", marginBottom: "5px" }}/>
                                    }
                                </h5>
                                {isInterestedBuying && (
                                    <div className="mt-3">
                                        <ul className="list-notes mx-2">
                                            <div className="row pb-2 fw-bold text-center" style={{borderBottom: "1px solid"}}>
                                                {["Agente", "Fecha", "Sentimiento"].map((header, index) => (
                                                    <div key={index} className="col">
                                                        <h5 className="fs-5">{header}</h5>
                                                    </div>
                                                ))}
                                            </div>
                        
                                            {dataContactInfo.buyingInterest?.map((interest, k) => (
                                                <li key={k} className="row py-2 text-center align-items-center" style={{borderBottom: "1px dashed"}}>
                                                    {[
                                                        interest.user ?? "Desconocido", 
                                                        dayjs(interest.date ?? new Date()).locale("es").format("DD/MM/YYYY HH:mm"), 
                                                        `${interest.interestedBuying?.percentage ?? 0}% ${interest.interestedBuying?.temperature ?? "Frío"}`
                                                    ].map((content, index) => (
                                                        <div key={index} className="col">{content}</div>
                                                    ))}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>

        {/* Modal para mostrar la información de las notas */}
        <Modal
            status={modalViewNote}
            changeStatus={setModalViewNote}
            title= "Información de la nota"
            width={"600px"}
        >
            <Content>
                <form style={{ width: "100%" }}>
                    <div>
                        <div className="su-control mt-2 text-center">
                            <ul>
                                <li>
                                    <h4>Creada por:</h4>
                                    <p>{noteSelected.agent}</p>
                                </li>
                                <li>
                                    <h4>Creada el:</h4>
                                    <p>
                                        {dayjs(noteSelected.date).locale("es").format("DD MMMM YYYY - HH:mm a")}
                                    </p>
                                </li>
                                <li>
                                    <h4>Contenido:</h4>
                                    <p>{noteSelected.note}</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="row justify-content-end bd col-12 mt-4">
                        <a
                            href="javascript:;"
                            className="btn btn-lg btn-default mr-1"
                            onClick={() => {
                                setModalViewNote((prevMessage) => { return false});
                            }}
                        >
                            Cerrar
                        </a>
                    </div>
                </form>


            </Content>
        </Modal>
    </>
)
}

export default ContactInfo;

const Div = styled.div`
    label {
        font-size: 14px;
    }

    input,
    textarea {
        font-size: 1em;
    }
`;
const Content = styled.div`
  // display: flex;
  // flex-direction: column;
  // align-items: center;
    h1 {
        font-size: 42px;
        font-weight: 700;
        margin-bottom: 10px;
        text-align: center;
    }
    li {
        padding: 10px 5px;
        border-bottom: 1px solid rgb(0, 0, 0, 0.05);
    }
    li:hover {
        background: rgb(0, 0, 0, 0.05);
    }
    p {
        font-size: 18px;
        margin-bottom: 0px;
    }
    input {
        padding: 10px;
        border-radius: 0px;
        font-size: 17px;
    }
    img.img-answer {
        cursor: pointer;
        width: auto;
        height: 85px;
        object-fit: scale-down;
    }
    .content-img {
        position: relative;
    }
    .content-img img:hover {
        opacity: 0.6;
    }
`;
